/* eslint-disable import/no-anonymous-default-export */
import {  Layout, notification, Typography } from "antd";
import { Header } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import UsuariosContext from "../contexts/UsuariosContext";
import NavMenu, { MenuItem } from "./NavMenu";


const StyledHeader = styled(Header)`
text-align:center;
color:white;
`;

const StyledLayout = styled(Layout)`
height:100%;
`

const StyledBody = styled(Layout)`
margin-left: 250px;
width: calc(100% - 250px);
`;

const StyledContent = styled.div<{ maxWidth?: number }>`
padding:2rem;
max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}%` : '1200px')};
width: 90%;
margin-left: auto;
margin-right: auto;
padding-top: 4rem;
`;

const StyledSider = styled(Sider)`
background-color:#212121;
position: fixed;
left: 0;
top: 0;
z-index: 2;
height: 100%;
overflow: auto;

flex: 0 0 250px!important;
max-width: 250px!important;
min-width: 250px!important;
width: 250px!important;
`;


interface MainLayoutProps {
    children: React.ReactNode,
    title?: string,
    maxContentWidth?: number
}

export default (props: MainLayoutProps) => {
    const navigate = useNavigate();
    const context = useContext(UsuariosContext);
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        const isTokenValid = context.checkAuth();
        if (!isTokenValid) {
            notification.info({
                message: 'Su sesion ha expirado (30 dias). Por favor, inicie sesion nuevamente...',
                duration: 5,
                placement: 'bottomRight'
            })
            setTimeout(() => context.signOut(),5000);
        }
    }, []);

    const menuItems: MenuItem[] = [
        {
            title:"Home",
            selectedPath:"/",
            key:'home',
            onClick:()=>navigate("/")
            
        },
        {
            title:"Correo",
            selectedPath:"/correo",
            key:'correo',
            permissions:["Correo.*"],
            items:[
                {
                    title:"Cargar rendiciones",
                    selectedPath:"/correo/correo-argentino/cargar-rendiciones",
                    key:"CargarRendicionesCorreoArgentino",
                    onClick: () => navigate("/correo/correo-argentino/cargar-rendiciones"),
                    permissions:["Correo.CorreoArgentino.CargarRendiciones"]
                }
            ]
        },
        {
            title:"Convenios de pago",
            selectedPath:"/convenios-pago",
            key:"convenios-pago",
            permissions:["ConvenioPago.*"],
            items:[
                {
                    title:"Infractores",
                    selectedPath:"/convenios-pago/infractores",
                    onClick: () => navigate("/convenios-pago/infractores"),
                    key:"ConvenioPago.Crear",
                    permissions: ["ConvenioPago.Crear"]
                },
                {
                    title:"Convenios generados",
                    selectedPath:"/convenios-pago",
                    onClick: () => navigate("/convenios-pago"),
                    key:"ConvenioPago.Listar",
                    permissions: ["ConvenioPago.Listar"]
                },
                {
                    title:"Listar configuraciones",
                    selectedPath:"/convenios-pago/configuraciones",
                    onClick: () => navigate("/convenios-pago/configuraciones"),
                    key:"ConveniosPagoConfiguracion.Listar",
                    permissions: ["ConveniosPagoConfiguracion.Listar"]
                },
                {
                    title:"Nueva configuración",
                    selectedPath:"/convenios-pago/configuraciones/guardar",
                    onClick: () => navigate("/convenios-pago/configuraciones/guardar"),
                    key:"ConveniosPagoConfiguracion.Crear",
                    permissions: ["ConveniosPagoConfiguracion.Crear"]
                }
            ]

        },
        {
            title:"Call Center",
            selectedPath:"/callcenter",
            key:"callcenter",
            permissions:["CallCenter.*"],
            items:[
                {
                    title:"Infractores",
                    selectedPath:"/callCenter/infractores*",
                    onClick: () => navigate("/callCenter/infractores"),
                    key:"CallCenter.ListarInfractores",
                    permissions: ["CallCenter.ListarInfractores"]
                },
                {
                    title:"Buscar infracciones",
                    selectedPath:"/callCenter/detalleInfracciones*",
                    onClick: () => navigate("/callCenter/detalleInfracciones"),
                    key:"CallCenter.DetalleInfracciones",
                    permissions: ["CallCenter.ListarInfractores"]
                },
               
            ]
        },
        {
            title:"Juzgado",
            selectedPath:"/juzgado/configuraciones/guardar",
            key:'juzgado',
            permissions:["Juzgado.*"],
            items:[
                {
                    title:"Listar configuraciones juzgado",
                    selectedPath:"/juzgado/configuraciones",
                    key:"JuzgadoConfiguracion.Listar",
                    onClick: () => navigate("/juzgado/configuraciones"),
                    permissions: ["JuzgadoConfiguracion.Listar"]
                },
                {
                    title:"Nueva Configuracion",
                    selectedPath:"/juzgado/configuraciones/guardar",
                    key:"GuardarConfiguracionJuzgado",
                    onClick: () => navigate("/juzgado/configuraciones/guardar"),
                    permissions:["ConfiguracionJuzgado.Crear"]
                }
            ]
        },
        {
            title:"Neuralvision",
            selectedPath:"/neuralvision*",
            key:"neuralvision",
            permissions:["ConfiguracionAnalitica.*", "EquipoProcesamiento.*"],
            items:[
                {
                    title:"Configuraciones de analítica",
                    selectedPath: "/neuralvision/configuraciones-analitica",
                    onClick: () => navigate("/neuralvision/configuraciones-analitica"),
                    key:"ConfiguracionAnalitica.list",
                    permissions: ["ConfiguracionAnalitica.Listar"]
                },
                /*
                {
                    title:"Crear configuración analítica",
                    selectedPath: "/neuralvision/configuraciones-analitica/guardar",
                    onClick: () => navigate("/configuraciones-analitica/guardar"),
                    key:"ConfiguracionAnalitica.save",
                    permissions: ["ConfiguracionAnalitica.Crear"]
                },*/
                {
                    title:"Equipos de procesamiento",
                    selectedPath: "/neuralvision/equipos-procesamiento",
                    onClick: () => navigate("/neuralvision/equipos-procesamiento"),
                    key:"EquipoProcesamiento.list",
                    permissions: ["EquipoProcesamiento.Listar"]
                },
                /*
                {
                    title:"Crear equipo de procesamiento",
                    selectedPath: "/neuralvision/equipos-procesamiento/guardar",
                    onClick: () => navigate("/neuralvision/equipos-procesamiento/guardar"),
                    key:"EquipoProcesamiento.save",
                    permissions: ["EquipoProcesamiento.Crear"]
                }*/
            ]
        },
        {
            title: "Códigos de infracción",
            selectedPath: "/codigos-infraccion*",
            key: "codigos-infraccion",
            permissions: ["CodigoInfraccion.*"],
            items: [
                {
                    title: "Listar",
                    selectedPath: "/codigos-infraccion",
                    onClick: () => navigate("/codigos-infraccion"),
                    key: "CodigoInfraccion.listar",
                    permissions: ["CodigoInfraccion.Listar"]


                },
                {
                    title: "Crear",
                    onClick: () => navigate("/codigos-infraccion/guardar"),
                    selectedPath: "/codigos-infraccion/guardar",
                    key: "CodigoInfraccion.crear",
                    permissions: ["CodigoInfraccion.Crear"]
                }
            ]
        },
        {
            title: "Usuarios",
            selectedPath: "/usuarios*",
            key: "usuarios",
            permissions: ["Usuario.*"],
            items: [
                {
                    title: "Listar",
                    selectedPath: "/usuarios",
                    onClick: () => navigate("/usuarios"),
                    key: "Usuarios.listar",
                    permissions: ["Usuario.Listar"]


                },
                {
                    title: "Crear",
                    onClick: () => navigate("/usuarios/guardar"),
                    selectedPath: "/usuarios/guardar",
                    key: "Usuarios.crear",
                    permissions: ["Usuario.Crear"]
                }
            ]
        },

        {
            title: "Agentes",
            selectedPath: "/agentes*",
            key: "agentes",
            permissions: ["Agente.*"],
            items: [
                {
                    title: "Listar",
                    selectedPath: "/agentes",
                    onClick: () => navigate("/agentes"),
                    key: "agentes.listar",
                    permissions: ["Agente.Listar"]


                },
                {
                    title: "Crear",
                    onClick: () => navigate("/agentes/guardar"),
                    selectedPath: "/agentes/guardar",
                    key: "agentes.crear",
                    permissions: ["Agente.Crear"]
                }
            ]
        },
        {
            title: "Unidades de prod.",
            selectedPath: "/unidades-produccion*",
            key: "unidad-produccion",
            permissions: ["UnidadProduccion.*"],
            items: [
                {
                    title: "Listar",
                    selectedPath: "/unidades-produccion",
                    onClick: () => navigate("/unidades-produccion"),
                    key: "UnidadProduccion.listar",
                    permissions: ["UnidadProduccion.Listar"]


                },
                {
                    title: "Crear",
                    onClick: () => navigate("/unidades-produccion/guardar"),
                    selectedPath: "/unidades-produccion/guardar",
                    key: "UnidadProduccion.crear",
                    permissions: ["UnidadProduccion.Crear"]
                }
            ]
        },
        {
            title: "Config. de prod.",
            selectedPath: "/configuraciones-produccion*",
            key: "configuracion-produccion",
            permissions: ["ConfiguracionProduccion.*"],
            items: [
                {
                    title: "Listar",
                    selectedPath: "/configuraciones-produccion",
                    onClick: () => navigate("/configuraciones-produccion"),
                    key: "ConfiguracionProduccion.listar",
                    permissions: ["ConfiguracionProduccion.Listar"]


                },
                {
                    title: "Crear",
                    onClick: () => navigate("/configuraciones-produccion/guardar"),
                    selectedPath: "/configuraciones-produccion/guardar",
                    key: "ConfiguracionProduccion.crear",
                    permissions: ["ConfiguracionProduccion.Crear"]
                }
            ]
        },
        {
            title: "Equipos",
            selectedPath: "/equipos*",
            key: "equipos",
            permissions: ["Equipo.*"],
            items: [
                {
                    title: "Listar",
                    selectedPath: "/equipos",
                    onClick: () => navigate("/equipos"),
                    key: "equipos.listar",
                    permissions: ["Equipo.Listar"]


                },
                {
                    title: "Crear",
                    onClick: () => navigate("/equipos/guardar"),
                    selectedPath: "/equipos/guardar",
                    key: "equipos.crear",
                    permissions: ["Equipo.Crear"]
                }
            ]
        },

        {
            title: "Estadisticas",
            selectedPath: "/estadisticas*",
            key: "estadisticas",
            onClick: () => navigate("/estadisticas"),
            permissions: ["Estadisticas.*"],
        },

        // {
        //     title: "Eventos",
        //     selectedPath: "/eventos*",
        //     key: "eventos-listar",
        //     permissions: ["Eventos.*"],
        //     onClick: () => navigate("/eventos")

        // },

        {
            title: "Infracciones",
            selectedPath: "/infracciones*",
            key: "infracciones-radar",
            permissions: ["InfraccionRadar.*"],
            onClick: () => navigate("/infracciones")

        },
        {
            title: "Precarga (lotes)",
            selectedPath: "/precarga*",
            key: "lotes-precarga",
            permissions: ["LotePrecarga.*"],
            onClick: () => navigate("/precarga/lotes"),
        },
        {
            title: "Renombrado",
            selectedPath: "/lotes-renombrado*",
            key: "renombrador",
            onClick: () => navigate("/lotes-renombrado"),
            permissions: ["LotesRenombrado.Listar"]
        },
        {
            title: "Consulta",
            key: "consulta",
            selectedPath: "/lotes-consulta",
            permissions: ["LoteConsulta.*"],
            items: [
                {
                    title: "Lotes",
                    selectedPath: "/lotes-consulta",
                    onClick: () => navigate("/lotes-consulta"),
                    key: "Lotes.listar",
                    permissions: ["LoteConsulta.Listar"]
                },
                {
                    title: "Cargar consulta",
                    selectedPath: "/lotes-consulta/cargar",
                    onClick: () => navigate("/lotes-consulta/cargar"),
                    key: "Consulta.cargar",
                    permissions: ["LoteConsulta.CargarConsulta"]
                }
            ]
        },

        {
            title: "Verificacion",
            onClick: () => navigate("/verificacion"),
            key: "Lotes.verificar",
            selectedPath: "/verificacion*",
            permissions: ["LoteConsulta.Verificar"]
        },
        {
            title: "Exportación",
            key: "exportacion",
            selectedPath: "/lotes-exportacion",
            permissions: ["LoteExportacion.*"],
            onClick: () => navigate("/lotes-exportacion"),
        },
        {
            title: "Impresión",
            key: "impresion",
            permissions: ["LoteImpresion.Listar"],
            items: [
                {
                    title: "Imprimir lote",
                    key: "Imprimir",
                    permissions: ["LoteImpresion.Listar"],
                    selectedPath: "/lotes-impresion",
                    onClick: () => navigate("/lotes-impresion"),
                },
                {
                    title: "Regenerar actas",
                    selectedPath: "/lotes-impresion/regenerar",
                    onClick: () => navigate("/lotes-impresion/regenerar"),
                    key: "Consulta.regenerar",
                    permissions: ["LoteConsulta.CargarConsulta"]
                }
            ]
        },
         {
            title: "Notificaciones",
            key: "notificaciones",
            permissions: ["Notificacion.Listar"],
            items: [
                {
                    title: "Notificar por correo electronico",
                    key: "email",
                    permissions: ["LoteImpresion.Listar"],
                    selectedPath: "/notificaciones/email",
                    onClick: () => navigate("/notificaciones/email"),
                },
                {
                    title: "Notificar por correo Postal",
                    key: "postal",
                    permissions: ["LoteImpresion.Listar"],
                    selectedPath: "/notificaciones/postal",
                    onClick: () => navigate("/notificaciones/postal"),
                },
                {
                    title: "Generar lote de notificación",
                    key: "lote-email",
                    permissions: ["LoteImpresion.Listar"],
                    selectedPath: "/notificaciones/lote-email",
                    onClick: () => navigate("/notificaciones/lote-email"),
                }
            ]
        }
    ];

    return (
        <StyledLayout>
            <StyledSider trigger={null} collapsible collapsed={collapsed}>
                <NavMenu showBrandBar={true} items={menuItems}/>
            </StyledSider>
            <StyledBody>
                <StyledContent maxWidth={props.maxContentWidth}>
                    {props.title && <Typography.Title level={3}>{props.title}</Typography.Title>}
                    {props.children}
                </StyledContent>
            </StyledBody>
        </StyledLayout>
    );
};

//<div style={{maxWidth:props.maxContentWidth ?? 1024,margin:'auto'}}></div>